import * as React from "react";
import { forwardRef } from "react";
const SvgCheckPartly = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 4, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCheckPartly);
export default ForwardRef;
